"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../../resources/constants");
var _default = {
  norway: {
    10: [{
      appliance: 'microwave',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 10,
      convertedKwh: 78.125,
      actualKwh: 77.76,
      quantity: 54,
      units: 'hours'
    }, {
      appliance: 'plasma_tv',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 10,
      convertedKwh: 78.125,
      actualKwh: 78,
      quantity: 195,
      units: 'hours'
    }, {
      appliance: 'clothes_dryer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 10,
      convertedKwh: 78.125,
      actualKwh: 78,
      quantity: 26,
      units: 'times'
    }],
    25: [{
      appliance: 'lawnmower',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 25,
      convertedKwh: 195.3125,
      actualKwh: 195.6,
      quantity: 163,
      units: 'hours'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 25,
      convertedKwh: 195.3125,
      actualKwh: 195,
      quantity: 130,
      units: 'hours'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 25,
      convertedKwh: 195.3125,
      actualKwh: 195.5,
      quantity: 85,
      units: 'hours'
    }],
    50: [{
      appliance: 'hair_dryer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 50,
      convertedKwh: 390.625,
      actualKwh: 390,
      quantity: 260,
      units: 'hours'
    }, {
      appliance: 'desktop_computer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 50,
      convertedKwh: 390.625,
      actualKwh: 391.68,
      quantity: 102,
      units: 'days'
    }, {
      appliance: 'dishwasher',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 50,
      convertedKwh: 390.625,
      actualKwh: 390.15,
      quantity: 289,
      units: 'hours'
    }],
    100: [{
      appliance: 'clothes_dryer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 100,
      convertedKwh: 781.25,
      actualKwh: 780,
      quantity: 260,
      units: 'times'
    }, {
      appliance: 'vacuum_cleaner',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 100,
      convertedKwh: 781.25,
      actualKwh: 777.6,
      quantity: 27,
      units: 'days'
    }, {
      appliance: 'coffee_brewer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 100,
      convertedKwh: 781.25,
      actualKwh: 777.6,
      quantity: 81,
      units: 'days'
    }],
    200: [{
      appliance: 'microwave',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 200,
      convertedKwh: 1562.5,
      actualKwh: 1555.2,
      quantity: 45,
      units: 'days'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 200,
      convertedKwh: 1562.5,
      actualKwh: 1548,
      quantity: 43,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 200,
      convertedKwh: 1562.5,
      actualKwh: 1561.09589,
      quantity: 28,
      units: 'days'
    }],
    300: [{
      appliance: 'coffee_brewer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 300,
      convertedKwh: 2343.75,
      actualKwh: 2342.4,
      quantity: 244,
      units: 'days'
    }, {
      appliance: 'stereo',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 300,
      convertedKwh: 2343.75,
      actualKwh: 2191.5,
      quantity: 5,
      units: 'years'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 300,
      convertedKwh: 2343.75,
      actualKwh: 2341.643836,
      quantity: 42,
      units: 'days'
    }],
    400: [{
      appliance: 'clothes_dryer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 400,
      convertedKwh: 3125,
      actualKwh: 3126,
      quantity: 1042,
      units: 'times'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 400,
      convertedKwh: 3125,
      actualKwh: 3132,
      quantity: 87,
      units: 'days'
    }, {
      appliance: 'microwave',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 400,
      convertedKwh: 3125,
      actualKwh: 3110.4,
      quantity: 90,
      units: 'days'
    }],
    500: [{
      appliance: 'playstation_tv',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 500,
      convertedKwh: 3906.25,
      actualKwh: 3905.28,
      quantity: 339,
      units: 'days'
    }, {
      appliance: 'plasma_tv',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 500,
      convertedKwh: 3906.25,
      actualKwh: 3907.2,
      quantity: 407,
      units: 'days'
    }, {
      appliance: 'vacuum_cleaner',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 500,
      convertedKwh: 3906.25,
      actualKwh: 3916.8,
      quantity: 136,
      units: 'days'
    }],
    750: [{
      appliance: 'stereo',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 750,
      convertedKwh: 5859.375,
      actualKwh: 5697.9,
      quantity: 13,
      units: 'years'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 750,
      convertedKwh: 5859.375,
      actualKwh: 5854.109589,
      quantity: 105,
      units: 'days'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 750,
      convertedKwh: 5859.375,
      actualKwh: 5868,
      quantity: 163,
      units: 'days'
    }],
    1000: [{
      appliance: 'lawnmower',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 1000,
      convertedKwh: 7812.5,
      actualKwh: 7804.8,
      quantity: 271,
      units: 'days'
    }, {
      appliance: 'playstation_tv',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 1000,
      convertedKwh: 7812.5,
      actualKwh: 7810.56,
      quantity: 678,
      units: 'days'
    }, {
      appliance: 'vacuum_cleaner',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 1000,
      convertedKwh: 7812.5,
      actualKwh: 7804.8,
      quantity: 271,
      units: 'days'
    }],
    1500: [{
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 1500,
      convertedKwh: 11718.75,
      actualKwh: 11736,
      quantity: 326,
      units: 'days'
    }, {
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 1500,
      convertedKwh: 11718.75,
      actualKwh: 11664,
      quantity: 0.54,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 1500,
      convertedKwh: 11718.75,
      actualKwh: 11708.21918,
      quantity: 210,
      units: 'days'
    }],
    2000: [{
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 2000,
      convertedKwh: 15625,
      actualKwh: 15621.6,
      quantity: 283,
      units: 'days'
    }, {
      appliance: 'playstation_tv',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 2000,
      convertedKwh: 15625,
      actualKwh: 16830.72,
      quantity: 4,
      units: 'years'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 2000,
      convertedKwh: 15625,
      actualKwh: 15610.9589,
      quantity: 280,
      units: 'days'
    }],
    2500: [{
      appliance: 'laptop',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 2500,
      convertedKwh: 19531.25,
      actualKwh: 19635.84,
      quantity: 64,
      units: 'years'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 2500,
      convertedKwh: 19531.25,
      actualKwh: 19513.69863,
      quantity: 350,
      units: 'days'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'heating',
      co2kg: 2500,
      convertedKwh: 19531.25,
      actualKwh: 19548,
      quantity: 543,
      units: 'days'
    }],
    4000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 4000,
      convertedKwh: 31250,
      actualKwh: 31320,
      quantity: 1.45,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 4000,
      convertedKwh: 31250,
      actualKwh: 31243.2,
      quantity: 566,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 4000,
      convertedKwh: 31250,
      actualKwh: 31277.67123,
      quantity: 561,
      units: 'days'
    }],
    8000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 8000,
      convertedKwh: 62500,
      actualKwh: 62424,
      quantity: 2.89,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 8000,
      convertedKwh: 62500,
      actualKwh: 62486.4,
      quantity: 1132,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 8000,
      convertedKwh: 62500,
      actualKwh: 62499.58904,
      quantity: 1121,
      units: 'days'
    }],
    12000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 12000,
      convertedKwh: 93750,
      actualKwh: 93744,
      quantity: 4.34,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 12000,
      convertedKwh: 93750,
      actualKwh: 93729.6,
      quantity: 1698,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 12000,
      convertedKwh: 93750,
      actualKwh: 93777.26027,
      quantity: 1682,
      units: 'days'
    }],
    16000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 16000,
      convertedKwh: 125000,
      actualKwh: 125064,
      quantity: 5.79,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 16000,
      convertedKwh: 125000,
      actualKwh: 124972.8,
      quantity: 2264,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 16000,
      convertedKwh: 125000,
      actualKwh: 124999.1781,
      quantity: 2242,
      units: 'days'
    }],
    20000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 20000,
      convertedKwh: 156250,
      actualKwh: 156168,
      quantity: 7.23,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 20000,
      convertedKwh: 156250,
      actualKwh: 156271.2,
      quantity: 2831,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 20000,
      convertedKwh: 156250,
      actualKwh: 156276.8493,
      quantity: 2803,
      units: 'days'
    }]
  },
  japan: {
    10: [{
      appliance: 'microwave',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 10,
      convertedKwh: 20,
      actualKwh: 19.6,
      quantity: 14,
      units: 'hours'
    }, {
      appliance: 'clothes_dryer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 10,
      convertedKwh: 20,
      actualKwh: 19.8,
      quantity: 18,
      units: 'times'
    }],
    25: [{
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 25,
      convertedKwh: 50,
      actualKwh: 49.91,
      quantity: 217,
      units: 'hours'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 25,
      convertedKwh: 50,
      actualKwh: 50,
      quantity: 50,
      units: 'hours'
    }],
    50: [{
      appliance: 'hair_dryer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 50,
      convertedKwh: 100,
      actualKwh: 100,
      quantity: 100,
      units: 'hours'
    }, {
      appliance: 'desktop_computer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 50,
      convertedKwh: 100,
      actualKwh: 96,
      quantity: 10,
      units: 'days'
    }, {
      appliance: 'dishwasher',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 50,
      convertedKwh: 100,
      actualKwh: 99.9,
      quantity: 111,
      units: 'hours'
    }],
    100: [{
      appliance: 'clothes_dryer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 100,
      convertedKwh: 200,
      actualKwh: 200.2,
      quantity: 182,
      units: 'times'
    }, {
      appliance: 'vacuum_cleaner',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 100,
      convertedKwh: 200,
      actualKwh: 192,
      quantity: 8,
      units: 'days'
    }],
    200: [{
      appliance: 'microwave',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 200,
      convertedKwh: 400,
      actualKwh: 403.2,
      quantity: 12,
      units: 'days'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 200,
      convertedKwh: 400,
      actualKwh: 397.44,
      quantity: 72,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 200,
      convertedKwh: 400,
      actualKwh: 391.52,
      quantity: 15,
      units: 'days'
    }],
    300: [{
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 300,
      convertedKwh: 600,
      actualKwh: 600.43,
      quantity: 23,
      units: 'days'
    }],
    400: [{
      appliance: 'clothes_dryer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 400,
      convertedKwh: 800,
      actualKwh: 799.7,
      quantity: 727,
      units: 'times'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 400,
      convertedKwh: 800,
      actualKwh: 800.4,
      quantity: 145,
      units: 'days'
    }, {
      appliance: 'microwave',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 400,
      convertedKwh: 800,
      actualKwh: 806.4,
      quantity: 24,
      units: 'days'
    }],
    500: [{
      appliance: 'playstation_tv',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 500,
      convertedKwh: 1000,
      actualKwh: 999.55,
      quantity: 304,
      units: 'days'
    }, {
      appliance: 'vacuum_cleaner',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 500,
      convertedKwh: 1000,
      actualKwh: 1008,
      quantity: 42,
      units: 'days'
    }],
    750: [{
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 750,
      convertedKwh: 1500,
      actualKwh: 1488.03,
      quantity: 57,
      units: 'days'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 750,
      convertedKwh: 1500,
      actualKwh: 1501.44,
      quantity: 272,
      units: 'days'
    }],
    1000: [{
      appliance: 'playstation_tv',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 1000,
      convertedKwh: 2000,
      actualKwh: 1999.1,
      quantity: 608,
      units: 'days'
    }, {
      appliance: 'vacuum_cleaner',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 1000,
      convertedKwh: 2000,
      actualKwh: 1992,
      quantity: 83,
      units: 'days'
    }],
    1500: [{
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 1500,
      convertedKwh: 3000,
      actualKwh: 2997.36,
      quantity: 543,
      units: 'days'
    }, {
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 1500,
      convertedKwh: 3000,
      actualKwh: 3000,
      quantity: 0.28,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 1500,
      convertedKwh: 3000,
      actualKwh: 3002.17,
      quantity: 115,
      units: 'days'
    }],
    2000: [{
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 2000,
      convertedKwh: 4000,
      actualKwh: 4008,
      quantity: 167,
      units: 'days'
    }, {
      appliance: 'playstation_tv',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 2000,
      convertedKwh: 4000,
      actualKwh: 3602.83,
      quantity: 3,
      units: 'years'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 2000,
      convertedKwh: 4000,
      actualKwh: 3994.18,
      quantity: 153,
      units: 'days'
    }],
    2500: [{
      appliance: 'laptop',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 2500,
      convertedKwh: 5000,
      actualKwh: 5259.6,
      quantity: 8,
      units: 'years'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 2500,
      convertedKwh: 5000,
      actualKwh: 5012.31,
      quantity: 192,
      units: 'days'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'heating',
      co2kg: 2500,
      convertedKwh: 5000,
      actualKwh: 5001.12,
      quantity: 906,
      units: 'days'
    }],
    4000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 4000,
      convertedKwh: 8000,
      actualKwh: 8000,
      quantity: 0.74,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 4000,
      convertedKwh: 8000,
      actualKwh: 7992,
      quantity: 333,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 4000,
      convertedKwh: 8000,
      actualKwh: 7988.37,
      quantity: 306,
      units: 'days'
    }],
    8000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 8000,
      convertedKwh: 16000,
      actualKwh: 16000,
      quantity: 1.48,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 8000,
      convertedKwh: 16000,
      actualKwh: 16008,
      quantity: 667,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 8000,
      convertedKwh: 16000,
      actualKwh: 16002.85,
      quantity: 613,
      units: 'days'
    }],
    12000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 12000,
      convertedKwh: 24000,
      actualKwh: 24000,
      quantity: 2.22,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 12000,
      convertedKwh: 24000,
      actualKwh: 24000,
      quantity: 1000,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 12000,
      convertedKwh: 24000,
      actualKwh: 23991.22,
      quantity: 919,
      units: 'days'
    }],
    16000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 16000,
      convertedKwh: 32000,
      actualKwh: 32000,
      quantity: 2.96,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 16000,
      convertedKwh: 32000,
      actualKwh: 31992,
      quantity: 1333,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 16000,
      convertedKwh: 32000,
      actualKwh: 32005.69,
      quantity: 1226,
      units: 'days'
    }],
    20000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 20000,
      convertedKwh: 40000,
      actualKwh: 40000,
      quantity: 3.7,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 20000,
      convertedKwh: 40000,
      actualKwh: 40008,
      quantity: 1667,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 20000,
      convertedKwh: 40000,
      actualKwh: 39994.06,
      quantity: 1532,
      units: 'days'
    }]
  },
  united_kingdom: {
    10: [{
      appliance: 'microwave',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 10,
      convertedKwh: 34,
      actualKwh: 34.56,
      quantity: 24,
      units: 'hours'
    }, {
      appliance: 'plasma_tv',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 10,
      convertedKwh: 34,
      actualKwh: 34,
      quantity: 85,
      units: 'hours'
    }, {
      appliance: 'clothes_dryer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 10,
      convertedKwh: 34,
      actualKwh: 33,
      quantity: 11,
      units: 'times'
    }],
    25: [{
      appliance: 'lawnmower',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 25,
      convertedKwh: 85,
      actualKwh: 85.2,
      quantity: 71,
      units: 'hours'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 25,
      convertedKwh: 85,
      actualKwh: 85.5,
      quantity: 57,
      units: 'hours'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 25,
      convertedKwh: 85,
      actualKwh: 85.1,
      quantity: 37,
      units: 'hours'
    }],
    50: [{
      appliance: 'hair_dryer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 50,
      convertedKwh: 170,
      actualKwh: 169.5,
      quantity: 113,
      units: 'hours'
    }, {
      appliance: 'desktop_computer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 50,
      convertedKwh: 170,
      actualKwh: 168.96,
      quantity: 44,
      units: 'days'
    }, {
      appliance: 'dishwasher',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 50,
      convertedKwh: 170,
      actualKwh: 170.1,
      quantity: 126,
      units: 'hours'
    }],
    100: [{
      appliance: 'clothes_dryer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 100,
      convertedKwh: 340,
      actualKwh: 339,
      quantity: 113,
      units: 'times'
    }, {
      appliance: 'vacuum_cleaner',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 100,
      convertedKwh: 340,
      actualKwh: 345.6,
      quantity: 12,
      units: 'days'
    }, {
      appliance: 'coffee_brewer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 100,
      convertedKwh: 340,
      actualKwh: 336,
      quantity: 35,
      units: 'days'
    }],
    200: [{
      appliance: 'microwave',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 200,
      convertedKwh: 679.8,
      actualKwh: 691.2,
      quantity: 20,
      units: 'days'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 200,
      convertedKwh: 679.8,
      actualKwh: 684,
      quantity: 19,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 200,
      convertedKwh: 679.8,
      actualKwh: 669,
      quantity: 12,
      units: 'days'
    }],
    300: [{
      appliance: 'coffee_brewer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 300,
      convertedKwh: 1019.7,
      actualKwh: 1017.6,
      quantity: 106,
      units: 'days'
    }, {
      appliance: 'stereo',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 300,
      convertedKwh: 1019.7,
      actualKwh: 876.6,
      quantity: 2,
      units: 'years'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 300,
      convertedKwh: 1019.7,
      actualKwh: 1003.56,
      quantity: 18,
      units: 'days'
    }],
    400: [{
      appliance: 'clothes_dryer',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 400,
      convertedKwh: 1359.6,
      actualKwh: 1359,
      quantity: 453,
      units: 'times'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 400,
      convertedKwh: 1359.6,
      actualKwh: 1368,
      quantity: 38,
      units: 'days'
    }, {
      appliance: 'microwave',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 400,
      convertedKwh: 1359.6,
      actualKwh: 1347.84,
      quantity: 39,
      units: 'days'
    }],
    500: [{
      appliance: 'playstation_tv',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 500,
      convertedKwh: 1699.5,
      actualKwh: 1705,
      quantity: 148,
      units: 'days'
    }, {
      appliance: 'plasma_tv',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 500,
      convertedKwh: 1699.5,
      actualKwh: 1699.2,
      quantity: 177,
      units: 'days'
    }, {
      appliance: 'vacuum_cleaner',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 500,
      convertedKwh: 1699.5,
      actualKwh: 1699.2,
      quantity: 59,
      units: 'days'
    }],
    750: [{
      appliance: 'stereo',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 750,
      convertedKwh: 2549.3,
      actualKwh: 2629.8,
      quantity: 6,
      units: 'years'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 750,
      convertedKwh: 2549.3,
      actualKwh: 2564.6,
      quantity: 46,
      units: 'days'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 750,
      convertedKwh: 2549.3,
      actualKwh: 2556,
      quantity: 71,
      units: 'days'
    }],
    1000: [{
      appliance: 'lawnmower',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 1000,
      convertedKwh: 3399,
      actualKwh: 3398.4,
      quantity: 118,
      units: 'days'
    }, {
      appliance: 'playstation_tv',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 1000,
      convertedKwh: 3399,
      actualKwh: 3398.4,
      quantity: 295,
      units: 'days'
    }, {
      appliance: 'vacuum_cleaner',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'household',
      co2kg: 1000,
      convertedKwh: 3399,
      actualKwh: 3398.4,
      quantity: 118,
      units: 'days'
    }],
    1500: [{
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'heating',
      co2kg: 1500,
      convertedKwh: 5098,
      actualKwh: 5112,
      quantity: 142,
      units: 'days'
    }, {
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 1500,
      convertedKwh: 5098,
      actualKwh: 5184,
      quantity: 0.24,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 1500,
      convertedKwh: 5098,
      actualKwh: 5073.6,
      quantity: 91,
      units: 'days'
    }],
    2000: [{
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 2000,
      convertedKwh: 6798,
      actualKwh: 6789.6,
      quantity: 123,
      units: 'days'
    }, {
      appliance: 'playstation_tv',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 2000,
      convertedKwh: 6798,
      actualKwh: 8415,
      quantity: 2,
      units: 'years'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 2000,
      convertedKwh: 6798,
      actualKwh: 6801.9,
      quantity: 122,
      units: 'days'
    }],
    2500: [{
      appliance: 'laptop',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'electronics',
      co2kg: 2500,
      convertedKwh: 8497.6,
      actualKwh: 8590.7,
      quantity: 28,
      units: 'years'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 2500,
      convertedKwh: 8497.6,
      actualKwh: 8474.5,
      quantity: 152,
      units: 'days'
    }, {
      appliance: 'portable_heater',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'heating',
      co2kg: 2500,
      convertedKwh: 8497.6,
      actualKwh: 8496,
      quantity: 236,
      units: 'days'
    }],
    4000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 4000,
      convertedKwh: 13596,
      actualKwh: 13608,
      quantity: 0.63,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 4000,
      convertedKwh: 13596,
      actualKwh: 13579,
      quantity: 246,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 4000,
      convertedKwh: 13596,
      actualKwh: 13603.8,
      quantity: 244,
      units: 'days'
    }],
    8000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 8000,
      convertedKwh: 27192,
      actualKwh: 27216,
      quantity: 1.26,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 8000,
      convertedKwh: 27192,
      actualKwh: 27213.6,
      quantity: 493,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 8000,
      convertedKwh: 27192,
      actualKwh: 27207.7,
      quantity: 488,
      units: 'days'
    }],
    12000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 12000,
      convertedKwh: 40788,
      actualKwh: 40792.8,
      quantity: 1.89,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 12000,
      convertedKwh: 40788,
      actualKwh: 40792.8,
      quantity: 739,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 12000,
      convertedKwh: 40788,
      actualKwh: 40811.5,
      quantity: 732,
      units: 'days'
    }],
    16000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 16000,
      convertedKwh: 54385,
      actualKwh: 54432,
      quantity: 2.52,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 16000,
      convertedKwh: 54385,
      actualKwh: 54372,
      quantity: 985,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 16000,
      convertedKwh: 54385,
      actualKwh: 54359,
      quantity: 975,
      units: 'days'
    }],
    20000: [{
      appliance: 'windmill',
      category: _constants.CATEGORY.energy,
      subCategory: 'production',
      applianceType: 'overall',
      co2kg: 20000,
      convertedKwh: 67981,
      actualKwh: 68040,
      quantity: 3.15,
      units: 'days'
    }, {
      appliance: 'oven',
      category: _constants.CATEGORY.energy,
      subCategory: 'small_usage',
      applianceType: 'kitchen',
      co2kg: 20000,
      convertedKwh: 67981,
      actualKwh: 68006,
      quantity: 1232,
      units: 'days'
    }, {
      appliance: 'total_household',
      category: _constants.CATEGORY.energy,
      subCategory: 'large_usage',
      applianceType: 'overall',
      co2kg: 20000,
      convertedKwh: 67981,
      actualKwh: 67963,
      quantity: 1219,
      units: 'days'
    }]
  }
};
exports.default = _default;
//# sourceMappingURL=energyLevels.js.map